/**
 * LandingPricing — single pricing card with feature checklist.
 *
 * Visual mirror of NoRework's "One price. Everything included."
 * card — TEAM LICENSE pill at top, big price line, sub line,
 * green-checkmark feature list, single primary CTA. ReadyRoomOps
 * locks D-07 to "Contact for quote", so the price slot reads
 * "Contact for quote" instead of a hard number — but the visual
 * pattern (peach/cream card, orange pill, green checkmarks) is
 * preserved.
 */

import { type ReactNode } from 'react'
import { CheckCircle2 }   from 'lucide-react'
import {
  PRICING_HEADLINE,
  PRICING_SUBHEAD,
  PRICING_BADGE,
  PRICING_TITLE,
  PRICING_PRICE,
  PRICING_PRICE_SUB,
  PRICING_FEATURES,
}                         from './landingCopy'

export interface LandingPricingProps {
  onCta: () => void
}

export function LandingPricing({ onCta }: LandingPricingProps): ReactNode {
  return (
    <section id="pricing" className="landing-section" aria-labelledby="pricing-h">
      <div className="landing-section__inner">
        <h2 id="pricing-h" className="landing-section__eyebrow">{PRICING_HEADLINE}</h2>
        <p className="landing-section__lede">{PRICING_SUBHEAD}</p>

        <div className="pricing-card">
          <span className="pricing-card__pill">{PRICING_BADGE}</span>
          <h3 className="pricing-card__title">{PRICING_TITLE}</h3>
          <p  className="pricing-card__price">{PRICING_PRICE}</p>
          <p  className="pricing-card__price-sub">{PRICING_PRICE_SUB}</p>

          <ul className="pricing-card__features">
            {PRICING_FEATURES.map((f) => (
              <li key={f} className="pricing-card__feature">
                <CheckCircle2 size={18} className="pricing-card__feature-check" strokeWidth={2.25} />
                <span>{f}</span>
              </li>
            ))}
          </ul>

          <div style={{ textAlign: 'center' }}>
            <button type="button" className="landing-cta landing-cta--primary" onClick={onCta}>
              Get a quote
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
